import { motion } from "framer-motion";

const services = [
  {
    icon: (
      <svg viewBox="0 0 24 24" className="w-10 h-10 fill-cyber-blue">
        <path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z" />
      </svg>
    ),
    title: "Cybersecurity Consultancy",
    desc: "Penetration testing, SIEM deployment, compliance audits, and incident response planning to protect your digital assets.",
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" className="w-10 h-10 fill-tech-green">
        <path d="M3.33 16.5H9l1 2.5h4l1-2.5h5.67L17 12l2.67-4.5H15l-1-2.5h-4L9 7.5H3.33L6 12l-2.67 4.5z" />
      </svg>
    ),
    title: "Network Design & Engineering",
    desc: "Enterprise-grade LAN/WAN design, routing protocols (OSPF/BGP), VLAN segmentation, and structured cabling.",
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" className="w-10 h-10 fill-cyber-blue">
        <path d="M1 9l2 2c4.97-4.97 13.03-4.97 18 0l2-2C16.93 2.93 7.08 2.93 1 9zm8 8l3 3 3-3c-1.65-1.66-4.34-1.66-6 0zm-4-4l2 2c2.76-2.76 7.24-2.76 10 0l2-2C15.14 9.14 8.87 9.14 5 13z" />
      </svg>
    ),
    title: "ISP Infrastructure Solutions",
    desc: "Core/edge network design, GPON fiber deployment, subscriber management, and NOC monitoring dashboards.",
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" className="w-10 h-10 fill-tech-green">
        <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
      </svg>
    ),
    title: "CCTV Installation & Monitoring",
    desc: "IP camera deployment, NVR configuration, remote mobile viewing, and video analytics for security operations.",
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" className="w-10 h-10 fill-cyber-blue">
        <path d="M9.4 16.6L4.8 12l4.6-4.6L8 6l-6 6 6 6 1.4-1.4zm5.2 0l4.6-4.6-4.6-4.6L16 6l6 6-6 6-1.4-1.4z" />
      </svg>
    ),
    title: "Web Development (React / Full-stack)",
    desc: "Custom React applications, headless CMS integration, REST/GraphQL APIs, and performant cloud-deployed front-ends.",
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" className="w-10 h-10 fill-tech-green">
        <path d="M19.14 12.94c.04-.3.06-.61.06-.94 0-.32-.02-.64-.07-.94l2.03-1.58c.18-.14.23-.41.12-.61l-1.92-3.32c-.12-.22-.37-.29-.59-.22l-2.39.96c-.5-.38-1.03-.7-1.62-.94l-.36-2.54c-.04-.24-.24-.41-.48-.41h-3.84c-.24 0-.43.17-.47.41l-.36 2.54c-.59.24-1.13.57-1.62.94l-2.39-.96c-.22-.08-.47 0-.59.22L2.74 8.87c-.12.21-.08.47.12.61l2.03 1.58c-.05.3-.07.62-.07.94s.02.64.07.94l-2.03 1.58c-.18.14-.23.41-.12.61l1.92 3.32c.12.22.37.29.59.22l2.39-.96c.5.38 1.03.7 1.62.94l.36 2.54c.05.24.24.41.48.41h3.84c.24 0 .44-.17.47-.41l.36-2.54c.59-.24 1.13-.56 1.62-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32c.12-.22.07-.47-.12-.61l-2.01-1.58zM12 15.6c-1.98 0-3.6-1.62-3.6-3.6s1.62-3.6 3.6-3.6 3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6z" />
      </svg>
    ),
    title: "IT Consulting & Automation",
    desc: "Network automation (Python/Ansible), configuration management, IT audits, and technology roadmap planning.",
  },
];

const container = {
  hidden: {},
  show: {
    transition: { staggerChildren: 0.1 },
  },
};

const itemAnim = {
  hidden: { opacity: 0, y: 30 },
  show: { opacity: 1, y: 0, transition: { duration: 0.5 } },
};

export default function Services() {
  return (
    <section className="min-h-screen pt-28 pb-20 px-6 lg:px-20 max-w-7xl mx-auto">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="mb-16"
      >
        <h1 className="text-5xl md:text-6xl font-bold">
          What We{" "}
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyber-blue to-tech-green">
            Offer
          </span>
        </h1>
        <p className="text-gray-400 text-lg mt-4 max-w-2xl">
          End-to-end technology services from infrastructure to software —
          engineered for security, scale, and performance.
        </p>
      </motion.div>

      <motion.div
        variants={container}
        initial="hidden"
        animate="show"
        className="grid md:grid-cols-2 lg:grid-cols-3 gap-6"
      >
        {services.map((s) => (
          <motion.div
            key={s.title}
            variants={itemAnim}
            className="glass rounded-2xl p-8 glass-hover glow-cyber group"
          >
            <div className="mb-5 group-hover:scale-110 transition-transform duration-300">
              {s.icon}
            </div>
            <h3 className="text-xl font-bold text-white mb-3">{s.title}</h3>
            <p className="text-gray-400 text-sm leading-relaxed">{s.desc}</p>
          </motion.div>
        ))}
      </motion.div>
    </section>
  );
}
